import StructuralUnitIcon from "@mui/icons-material/AccountBalance";
import ListStructuralUnits from "./List";
import { STRUCTURAL_UNITS, AdministrationServicePath } from "utils/constants";
import CreateStructuralUnits from "./Create";
import EditStructuralUnits from "./Edit";
import ShowStructuralUnits from "./Show";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU, tenants.MGU],
  icon: <StructuralUnitIcon />,
  name: AdministrationServicePath + STRUCTURAL_UNITS,
  title: "Структурни единици",
  list: <ListStructuralUnits />,
  create: <CreateStructuralUnits />,
  createPermission: permissions.canCreateStructuralUnits,
  edit: <EditStructuralUnits />,
  editPermission: permissions.canUpdateStructuralUnits,
  show: <ShowStructuralUnits />,
  showPermission: permissions.canPreviewStructuralUnits,
  permission: permissions.canPreviewStructuralUnits,
};
